/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Container, Row, UncontrolledTooltip, NavLink } from 'reactstrap';

import ReactTable, { ReactTableDefaults } from 'react-table';
import 'react-table/react-table.css';

import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';

import PesquisaRapida from '../Common/PesquisaRapida';
import PrettyCheckbox from '../Common/PrettyCheckbox';
import TooltippedCel from '../Common/TooltippedCel';
import Pagination from '../../Util/Pagination';

import { AlertasContext } from '../../Providers/Alertas';
import { BlockUiContext } from '../../Providers/BlockUi';

import ImpressoesDetalhes from '../Modais/ImpressoesDetalhes';
import EmissoesExclusao from '../Modais/EmissoesExclusao';
import ErroImpressaoGuiasEmitidas from '../Modais/ErroImpressaoGuiasEmitidas';
import EmissoesES from '../Modais/EmissoesES';

import { formataData } from '../../BaseFunctions';

import { getVal, formataCurrency } from '../../BaseFunctions';

import { LogsServiceAPI } from "../../Util/logsService"
import Cookies from 'js-cookie';



import './Emitidas.scss';
import infoImg from '../../Assets/information.jpg';

const isSimulacao = localStorage.getItem('isSimulacao') === 'true';
const isPro = localStorage.getItem('isPro') === 'true';

let pageSize = 10;

Object.assign(ReactTableDefaults, {
	pageSizeOptions: [10, 20, 25, 50, 100],
	defaultPageSize: 10,
	minRows: 10,
	// maxRows: 30,
	nextText: 'Próxima',
	previousText: 'Anterior',
	noDataText: 'Nenhum resultado encontrado',
	pageText: 'Pág.',
	ofText: 'de',
	rowsText: 'linhas',
	resizable: true,
});

function Emitidas() {
	const [rawData, setRawData] = useState([]);
	const [showData, setShowData] = useState([]);
	const [showDataPagination, setShowDataPagination] = useState([]);
	const [rawDocs, setRawDocs] = useState([]);
	const [rawDocsValorTotal, setRawDocsValorTotal] = useState([]);
	const [rawDocsReceita, setRawDocsReceita] = useState([]);
	const [rawDocsDestinatario, setRawDocsDestinatario] = useState([]);
	const [rawDocsVlPrincipal, setRawDocsVlPrincipal] = useState([]);
	const defaultSorted = [{ id: 'intNFE', desc: false }];
	const [detalhes, setDetalhes] = useState({});
	const [strBusca, setStrBusca] = useState('');
	const [blFiltroAtivo, setBlFiltroAtivo] = useState(false);
	const [blShowPesquisaRapida, setBlShowPesquisaRapida] = useState(false);
	const [seES, setSeES] = useState(false);
	const [erroImpressao, setErroImpressao] = useState([]);
	const [urlHomo, setUrlHomo] = useState("");
	const [pageData, setDataPage] = useState('');

	let reactTable = React.createRef();
	let ModalDetalhes = React.createRef();
	let ModalEmissoesExclusao = React.createRef();
	let ModalErroImpressao = React.createRef();
	let ModalImpressaoES = React.createRef();

	/* eslint-disable no-unused-vars */
	let onLoading;
	let showInfoMessage;
	let showSuccessMessage;
	let showWarningMessage;
	let showErrorMessage;
	/* eslint-enable no-unused-vars */

	useEffect(() => {
		handleReload();
		const notificar = localStorage.getItem('notificarImpressao');
		if (notificar === 'true') {
			showSuccessMessage('Guias emitidas com sucesso!');
		}
		localStorage.setItem('notificarImpressao', false);

		if (window.location.hostname == "ec2-34-206-89-100.compute-1.amazonaws.com") {
			setUrlHomo("http://www.testegnre.pe.gov.br/gnre/portal/GNRE_DisponibilidadeUF.jsp");
		} else {
			setUrlHomo("http://www.gnre.pe.gov.br/gnre/portal/GNRE_DisponibilidadeUF.jsp");
		}
	}, []);

	const handleReload = () => {
		let listaDocs = [];
		let listaDocsValorTotal = [];
		let listaDocsReceita = [];
		let listaDocsDestinatario = [];
		let listaDocsVlPrincipal = [];
		onLoading(true);
		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarEmitidas`)
			.then(response => {
				onLoading(false);
				const { data } = response;

				const rawData = data.map(original => ({ ...original, blSelected: false }));
				setRawData(rawData);
				setShowData(rawData);
				setShowDataPagination(rawData);
				// setShowData(rawData.slice(0,10));

				rawData.forEach(el => {
					el.listDocumentosFiscais.forEach(e => {
						listaDocs.push(e.strDocumento);
						listaDocsValorTotal.push(e.vlTotal);
						listaDocsReceita.push(e.strReceita);
						listaDocsDestinatario.push(e.strDestinatario);
						listaDocsVlPrincipal.push(e.vlPrincipal);
					});
				});

				setRawDocs(listaDocs);
				setRawDocsValorTotal(listaDocsValorTotal);
				setRawDocsReceita(listaDocsReceita);
				setRawDocsDestinatario(listaDocsDestinatario);
				setRawDocsVlPrincipal(listaDocsVlPrincipal);

			})
			.catch(() => {
				onLoading(false);
				showErrorMessage('Erro ao carregar dados');
				setRawData([]);
				setShowData([]);
			});
	};

	const onUpdatePesquisaRapida = (data, strBusca, blShow) => {
		setShowData(data);
		setStrBusca(strBusca);
		setBlShowPesquisaRapida(blShow);
	};

	const textFilterMethod = (filter, row) =>
		row[filter.id] && row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1;

	const textFilterSituacao = (filter, row) => {

		if (filter.value.toLowerCase() == 'impresso') {
			return row[filter.id] && row[filter.id].toLowerCase().indexOf(filter.value.toLowerCase()) > -1;
		}

		if (filter.value.toLowerCase() == 'não impresso') {
			let teste = 'Sucesso';
			return row[filter.id] && row[filter.id].toLowerCase().indexOf(teste.toLowerCase()) > -1;
		}

	}

	const dateFilterMethod = (filter, row) => row[filter.id] && (new Date(row[filter.id]).toLocaleDateString()).indexOf(filter.value) > -1;

	const childPaginationValue = (page) => {
		setDataPage(page);
	}

	const handleTableSelectAllChange = ({ target: { checked } }) => {
		const firstPageIndex = (pageData - 1) * pageSize;
		const lastPageIndex = firstPageIndex + pageSize;

		const dadosLista = showData.slice(firstPageIndex, lastPageIndex);

		let listaPaginada = dadosLista.map(original => ({ ...original, blSelected: checked }))

		const valor = rawData.map( row => {
			listaPaginada.map(el => {
				if (row.id == el.id){
					row.blSelected = el.blSelected;
				}
			});
			return row;
		});

		setShowDataPagination(valor);
		setShowData(valor);

		setShowDataPagination(valor.map(original => ({ ...original, blSelected: checked })));
		//setShowData(valor.map(original => ({ ...original, blSelected: checked })));
		// console.log(rawData.slice(0, ReactTableDefaults.minRows))
	};

	const handleTableSelectChange = (row, target) => {
		setShowData([
			...showData.slice(0, row.index),
			{ ...row.original, [target.name]: target.checked },
			...showData.slice(row.index + 1),
		]);
	};

	const logImpressao = () => {
		// Pega log ao imprimir a guia e envia para o Painel de Acessos do Principal
		let logsServiceApi = new LogsServiceAPI();
 		logsServiceApi.salvarLog(Cookies.get('bG9naW4'), 353, 3);
	}

	const imprimirSelecionadas = (id = null) => {
		onLoading(true);
		logImpressao();
		if (id != null && id.uf == "ES" && seES == false) {
			ModalImpressaoES.current.openModal();
			setSeES(true);
		} else {
			setSeES(false);
		}
		const selected = id != null ? [id.id] : showData.filter(x => x.blSelected).map(x => x.id);

		if (selected != null) {
			HttpUtil.eco_POST_CONFIG(`${Config.urls.API_URL_BASE}Documento/Imprimir`, selected, {
				headers: { Authorization: `bearer ${localStorage.getItem('AccessToken')}` },
			})
			.then(response => {
				const { data } = response;
				var binary = window.atob(data.resposta);
				var len = binary.length;
				var bytes = new Uint8Array(len);
				for (let i = 0; i < len; i++) {
					bytes[i] = binary.charCodeAt(i);
				}
				const file = new Blob([bytes.buffer], { type: 'application/pdf' });
				if (data.resposta !== "") {
					if (data.erro) {
						setErroImpressao(data.erro);
					}
					onLoading(false);
					var a = document.createElement('a');
					document.body.appendChild(a);
					a.style = 'display: none';
					const fileURL = URL.createObjectURL(file);
					window.open(fileURL);
					handleReload();
					} else {
						onLoading(false);
						ModalErroImpressao.current.openModal();
					}
				})
			.catch(() => {
				onLoading(false);
				showErrorMessage('Ocorreu um erro ao obter o pdf da receita');
			});
		}
	};

	useEffect(() => {
		if (erroImpressao.length > 0) {
			ModalErroImpressao.current.openModal();
		}

	}, [erroImpressao]);

	useEffect(() => {
		detalhes.id && ModalDetalhes.current.openModal();
	}, [detalhes]);

	const MostrarModalDetalhes = (id, recibo, status) => {
		onLoading(true);

		var url = `${Config.urls.API_URL_BASE}Documento/BuscarDetalhes/${id}`;

		HttpUtil.eco_GET(url).then(response => {
			setDetalhes({ guias: [] });

			if (response.data.length > 0) {
				setDetalhes({
					id: id,
					razaoSocial: response.data[0].razaoSocial,
					documento: response.data[0].documentoDestinatario,
					guias: response.data,
					status,
				});
				onLoading(false);
			}
		});
	};

	const mostrarDestacados = (row, valor, tooltip = false) => {
		return (
			<div className={`row-mostrar-destacados ${row.original.status === 'Sucesso' ? 'sucesso' : ''}`}>
				{tooltip ? <TooltippedCel text={valor} /> : valor}
			</div>
		);
	};

	const imprimirFiltro = () => {
		const notNullid = showData.filter(x => x.blSelected).map(x => x.uf);
		for (let i=0;i<notNullid.length;i++){
			if (notNullid[i] == "ES" && seES == false) {
				ModalImpressaoES.current.openModal();
				setSeES(true);
				//imprimirSelecionadas();
			}
		}
		imprimirSelecionadas();
	}

	const habilitarImpressao = row => (
		<Row>
			<Col className="nav-item m-0" onClick={() => imprimirSelecionadas(row.original)}>
			{/* <Col className="nav-item m-0" onClick={() => imprimirFiltro(row.original)}> */}
				<span id={'printTip' + row.original.id}>
					<i className="fas fa-print" />
				</span>
				<UncontrolledTooltip placement="top" target={'printTip' + row.original.id}>
					Imprimir
				</UncontrolledTooltip>
			</Col>
			<Col
				className="nav-item m-0"
				onClick={() => MostrarModalDetalhes(row.original.id, row.original.recibo, row.original.status)}>
				<span id={'detailTip' + row.original.id}>
					<i className="fas fa-file-alt" />
				</span>
				<UncontrolledTooltip placement="top" target={'detailTip' + row.original.id}>
					Detalhes
				</UncontrolledTooltip>
			</Col>
		</Row>
	);

	const renderDocumentosFiscais = row => {
		const listDocumentosFiscais = getVal(row, 'original.listDocumentosFiscais') || [];

		const columnsDocFiscais = [
			{
				Header: () => <div className="text-left">N. DOCUMENTO</div>,
				accessor: 'strDocumento',
				className: 'text-left',
				width: 100,
				Cell: row => (row.value.length >= 35 ? parseInt(row.value.substring(25, 34)) : row.value),
			},
			{
				Header: () => <div className="text-left">TIPO</div>,
				accessor: 'strTipoNota',
				className: 'text-left',
				width: 50,
			},
			{
				Header: () => <div className="text-left">DESTINATÁRIO</div>,
				accessor: 'strDestinatario',
				className: 'text-left',
				Cell: row => <TooltippedCel text={row.value} />,
			},
			{
				Header: 'RECEITA',
				accessor: 'strReceita',
				className: 'text-center',
				width: 80,
			},
			{
				Header: 'FCP',
				accessor: 'receitaFcp',
				className: 'text-center',
				width: 60,
				Cell: row => {
					const infoFCP_id = `info-fcp-id-${new Date().getTime()}`;

					return (
						<div>
							{row.value}
							{row.original.receitaFcp === 'Não' && row.original.vlFcp > 0 ? (
								<span>
									&nbsp;
									<i id={infoFCP_id} className="fas fa-info-circle text-info" />
									<UncontrolledTooltip placement="right" target={infoFCP_id}>
										A guia de FCP deverá ser emitida diretamente no Portal da SEFAZ, relativo ao
										estado
									</UncontrolledTooltip>
								</span>
							) : null}
						</div>
					);
				},
			},
			{
				Header: 'PRINCIPAL',
				accessor: 'vlPrincipal',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 100,
			},
			{
				Header: 'MULTA',
				accessor: 'vlMulta',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 100,
			},
			{
				Header: 'JUROS',
				accessor: 'vlJuros',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 100,
			},
			{
				Header: 'VALOR TOTAL',
				accessor: 'vlValor',
				className: 'text-center',
				Cell: row => formataCurrency(row.value),
				width: 150,
			},
		];

		return (
			<Card className="documentos-fiscais">
				<CardHeader>DOCUMENTOS FISCAIS</CardHeader>
				<CardBody>
					<ReactTable
						data={listDocumentosFiscais}
						filterable={false}
						columns={columnsDocFiscais}
						showPagination={false}
						defaultSorted={[{ id: 'strEmitente', desc: false }]}
						minRows={1}
					/>
				</CardBody>
			</Card>
		);
	};

	const columns = [
		{
			Header: () => <div />,
			expander: true,
			// eslint-disable-next-line react/prop-types
			Expander: ({ isExpanded }) => (
				<div>{isExpanded ? <i className="fas fa-minus" /> : <i className="fas fa-plus" />}</div>
			),
		},
		{
			Header: () => (
				<div className="text-center">
					<PrettyCheckbox
						strTitle="Essa opção seleciona todos os documentos existentes nesse grupo e não somente a quantidade exibida."
						checked={showDataPagination.every(original => original.blSelected)}
						id="selectAll"
						onChange={e => handleTableSelectAllChange(e)}
						// onChange={() => toggleAllPageRowsSelected()}
						iconSuccess="fas fa-check-double"
						simpleSelection
					/>
				</div>
			),
			accessor: 'blSelected',
			Cell: row => (
				<PrettyCheckbox
					strTitle="Selecionar"
					checked={row.original.blSelected}
					id="blSelected"
					onChange={({ target }) => handleTableSelectChange(row, target)}
					iconSuccess="fas fa-check"
					simpleSelection
				/>
			),
			filterable: false,
			sortable: false,
			className: 'text-center',
			width: 35,
		},
		{
			Header: () => <div className="text-left">Emitente</div>,
			accessor: 'razaoSocialEmissor',
			filterMethod: textFilterMethod,
			className: 'text-left',
			Cell: row => mostrarDestacados(row, row.value, true),
		},
		{
			Header: 'Pagamento',
			accessor: 'data',
			filterMethod: dateFilterMethod,
			className: 'text-center',
			Cell: row => mostrarDestacados(row, formataData(row.value), false),
			width: 115,
		},
		{
			Header: 'UF',
			accessor: 'uf',
			filterMethod: textFilterMethod,
			className: 'text-center',
			width: 50,
		},
		{
			Header: 'Valor',
			accessor: 'valorTotal',
			filterMethod: (filter, row) => row[filter.id] && row[filter.id].toString().includes(filter.value),
			className: 'text-center',
			width: 100,
			Cell: row => mostrarDestacados(row, formataCurrency(row.value)),
		},
		{
			Header: 'Situação',
			accessor: 'status',
			filterMethod: textFilterSituacao,
			className: 'text-center',
			width: 150,
			Cell: row => mostrarDestacados(row, row.value === 'Sucesso' ? 'Não Impresso' : row.value),
		},
		{
			Header: '',
			className: 'text-center',
			filterable: false,
			sortable: false,
			width: 80,
			Cell: row => habilitarImpressao(row),
		},
	];

	return (
		<main id="emitidas">
			<AlertasContext.Consumer>
				{alertas => {
					showInfoMessage = alertas.info;
					showSuccessMessage = alertas.success;
					showWarningMessage = alertas.warning;
					showErrorMessage = alertas.error;
				}}
			</AlertasContext.Consumer>
			<BlockUiContext.Consumer>
				{blockUi => {
					onLoading = blockUi.handleLoading;
				}}
			</BlockUiContext.Consumer>
			<ImpressoesDetalhes ref={ModalDetalhes} value={detalhes} onClosed={handleReload} />
			<ErroImpressaoGuiasEmitidas ref={ModalErroImpressao} listErro={erroImpressao} onClosed={handleReload} />
			<EmissoesES ref={ModalImpressaoES} />
			<EmissoesExclusao
				ref={ModalEmissoesExclusao}
				value={showData.filter(x => x.blSelected).map(x => x.id)}
				onClosed={handleReload}
			/>
			<Row noGutters id="main-header">
				<Col>
					{/* <Row>
						<Col className="alert alert-danger">
							<strong>AVISO</strong>:O EcoGNRE está atualizado com as regras da versão 2.0 publicada em 16/01/2024 (inclusão de pagamento por PIX), porém, a guia é registrada e gerada, mas a WS da Sefaz não está retornando a mesma para impressão no momento. Recomendamos a impressão manual via <a href='https://www.gnre.pe.gov.br:444/gnre/v/guia/index' target='_blank'>Portal da GNRE</a> ou tente mais tarde via EcoGNRE.
						</Col>
					</Row> */}
					<Row style={{display: 'flex', position: 'relative', borderBottom: '2px solid #15545e', margin: '10px 0 10px 0'}}>
						<Row>
							<h1>Guias emitidas</h1>
							<span>
							<NavLink
								href={urlHomo}
								className="btn btn-secondary"
								target="_blank"
								style={{padding: '4px 10px 1px 10px', position: 'absolute', left: 'auto', right: '0', fontSize: 'small'}}
							>
								<>Verificar disponibilidade de emissão por UF </>
								<i className="fas fa-info-circle" />
							</NavLink>
							</span>
							<hr />
						</Row>
					</Row>
					<Row noGutters>
						<Col className="singleHeaderHeight">
							<Container id="buttons" className="p-0">
								<Row>
									<Col xs="auto p-0">
										<Button
											size="sm"
											color="primary"
											block
											// onClick={() => imprimirSelecionadas()}
											 onClick={() => imprimirFiltro()}
											disabled={
												!isSimulacao ? !showData.some(original => original.blSelected) : 'false'
											}>
											<i className="fas fa-print" /> Imprimir selecionadas
										</Button>
									</Col>
									<Col xs="auto p-0">
										<Button
											onClick={() => ModalEmissoesExclusao.current.openModal()}
											size="sm"
											color={`base-class ${
												showData.some(original => original.blSelected)
													? 'btn-info'
													: 'btn-secondary'
											}`}
											block
											disabled={
												!isSimulacao && !isPro
													? !showData.some(original => original.blSelected)
													: 'false'
											}>
											<i className="fas fa-trash-alt" /> Excluir
										</Button>
									</Col>
								</Row>
							</Container>
						</Col>
						<Col xs="6" className="singleHeaderHeight mobile-buttons">
							{blShowPesquisaRapida ? (
								<PesquisaRapida
									value={strBusca}
									blShow={blShowPesquisaRapida}
									rawData={rawData}
									rawDocs={rawDocs}
									rawDocsValorTotal={rawDocsValorTotal}
									rawDocsReceita={rawDocsReceita}
									rawDocsDestinatario={rawDocsDestinatario}
									rawDocsVlPrincipal={rawDocsVlPrincipal}
									onUpdate={onUpdatePesquisaRapida}
								/>
							) : (
								<Container className="p-0">
									<Row>
										<Col />
										<Col xs="auto p-0">
											<Button
												onClick={() => {
													setBlFiltroAtivo(!blFiltroAtivo);
													setShowData(rawData);
													setStrBusca('');
												}}
												color="link">
												<i className="ecoico ecoico-filtro" />
											</Button>
										</Col>
										<Col xs="auto p-0">
											<Button
												onClick={() => {
													setBlShowPesquisaRapida(true);
													setBlFiltroAtivo(false);
												}}
												color="link">
												{strBusca ? (
													<i className="fas fa-search-plus" />
												) : (
													<i className="fas fa-search" />
												)}
											</Button>
										</Col>
									</Row>
								</Container>
							)}
						</Col>
					</Row>
				</Col>
			</Row>
			<Row noGutters>
				<Col>
					<ReactTable
						className="table-emitidas"
						ref={reactTable}
						data={showData}
						filterable={blFiltroAtivo}
						columns={columns}
						showPagination={showData.length > 0}
						showPageSizeOptions={false}
						selectAll={false}
						PaginationComponent={Pagination}
						childPaginationValue={childPaginationValue}
						SubComponent={row => renderDocumentosFiscais(row)}
						// collapseOnDataChange={false}
						strTableInfo="Guias"
					/>
				</Col>
			</Row>
		</main>
	);
}

export default withRouter(Emitidas);
